module.exports = __webpack_public_path__ + "img/service_engineer_horn.16f4bb28.svg";